<template>
  <div>
    <div class="intro-y box p-5 mt-5">
      <div class="flex flex-col sm:flex-row sm:items-end xl:items-start">
        <form id="tabulator-html-filter-form" class="xl:flex sm:mr-auto">
          <div class="grid grid-cols-12 gap-x-2">
            <div class="col-span-6 md:col-span-4 xl:col-span-3 my-1">
              <div class="flex items-center sm:mr-2">
                <label class="mr-2">Field</label>
                <select id="tabulator-html-filter-field" v-model="filter.field" class="form-select">
                  <option value="name">Name</option>
                  <option value="short_code">Short Code</option>
                  <option value="synonyms">Synonyms</option>
                </select>
              </div>
            </div>
            <div class="col-span-6 md:col-span-3 xl:col-span-2 my-1">
              <div class="flex items-center sm:mr-2">
                <label class="mr-2">Type</label>
                <select id="tabulator-html-filter-type" v-model="filter.type" class="form-select w-fullo">
                  <option value="like" selected>like</option>
                  <option value="=">=</option>
                  <option value="<">&lt;</option>
                  <option value="<=">&lt;=</option>
                  <option value=">">></option>
                  <option value=">=">>=</option>
                  <option value="!=">!=</option>
                </select>
              </div>
            </div>
            <div class="col-span-6 md:col-span-4 xl:col-span-3 my-1">
              <div class="flex items-center sm:mr-2">
                <label class="mr-2">Value</label>
                <input id="tabulator-html-filter-value" v-model="filter.value" type="text" class="form-control sm:w-40" placeholder="Search..." />
              </div>
            </div>
            <div class="col-span-3 md:col-span-2 xl:col-span-1 my-1">
              <button id="tabulator-html-filter-go" type="button" class="btn btn-primary w-full" @click="onFilter">Go</button>
            </div>
            <div class="col-span-3 md:col-span-2 xl:col-span-1 my-1">
              <button id="tabulator-html-filter-reset" type="button" class="btn btn-secondary w-full" @click="onResetFilter">Reset</button>
            </div>
          </div>
        </form>
        <div class="flex mt-5 sm:mt-0">
          <a href="javascript:;" data-toggle="modal" data-target="#new-order-modal" class="btn btn-primary shadow-md mr-2" @click="resetForm">New {{ pageTitle }}</a>
          <div class="dropdown w-1/2 sm:w-auto">
            <button class="dropdown-toggle btn btn-outline-secondary w-full sm:w-auto" aria-expanded="false">
              <FileTextIcon class="w-4 h-4 mr-2" /> Export
              <ChevronDownIcon class="w-4 h-4 ml-auto sm:ml-2" />
            </button>
            <div class="dropdown-menu w-40">
              <div class="dropdown-menu__content box dark:bg-dark-1 p-2">
                <a id="tabulator-export-csv" href="javascript:;" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md" @click="onExportCsv">
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export CSV
                </a>
                <a id="tabulator-export-json" href="javascript:;" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md" @click="onExportJson">
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export JSON
                </a>
                <a id="tabulator-export-xlsx" href="javascript:;" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md" @click="onExportXlsx">
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export XLSX
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overflow-x-auto scrollbar-hidden">
        <div id="tabulator" ref="tableRef" class="mt-5 table-report table-report--tabulator"></div>
      </div>
    </div>

    <div id="new-order-modal" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="font-medium text-base mr-auto">New {{ pageTitle }}</h2>
          </div>
          <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
            <div class="col-span-12">
              <label for="attribute-name" class="form-label">Name</label>
              <input id="attribute-name" v-model="form.name" name="name" type="text" class="form-control flex-1" :class="{ 'border-theme-6': validate.name.$error }" placeholder="Name" />
              <template v-if="validate.name.$error">
                <div v-for="(error, index) in validate.name.$errors" :key="index" class="text-theme-6 mt-2">{{ error.$message }}</div>
              </template>
            </div>
            <div class="col-span-12">
              <label for="attribute-short-code" class="form-label">Short Code</label>
              <input id="attribute-short-code" v-model="form.short_code" name="short_code" type="text" class="form-control flex-1" :class="{ 'border-theme-6': validate.short_code.$error }" placeholder="Short Code" />
              <template v-if="validate.short_code.$error">
                <div v-for="(error, index) in validate.short_code.$errors" :key="index" class="text-theme-6 mt-2">{{ error.$message }}</div>
              </template>
            </div>
            <div class="col-span-12">
              <label for="attribute-synonyms" class="form-label">Synonyms</label>
              <textarea id="attribute-synonyms" v-model="form.synonyms" name="synonyms" class="form-control flex-1" rows="3" placeholder="Synonyms"></textarea>
            </div>
            <div class="col-span-12">
              <label for="attribute-order" class="form-label">Order</label>
              <input id="attribute-order" v-model="form.order" type="text" name="order" class="form-control flex-1" :class="{ 'border-theme-6': validate.order.$error }" placeholder="" />
              <template v-if="validate.order.$error">
                <div v-for="(error, index) in validate.order.$errors" :key="index" class="text-theme-6 mt-2">{{ error.$message }}</div>
              </template>
            </div>
          </div>
          <div class="modal-footer text-right">
            <button type="button" data-dismiss="modal" class="btn btn-outline-secondary w-32 mr-1">Cancel</button>
            <button type="button" class="btn btn-primary w-32" @click="submitForm">Save Details</button>
          </div>
        </div>
      </div>
    </div>

    <div id="success-notification-content" class="toastify-content hidden flex">
      <CheckCircleIcon class="text-theme-9" />
      <div class="ml-4 mr-4">
        <div class="font-medium">Details saved successfully!</div>
        <div class="text-gray-600 mt-1"></div>
      </div>
    </div>
    <div id="failed-notification-content" class="toastify-content hidden flex">
      <XCircleIcon class="text-theme-6" />
      <div class="ml-4 mr-4">
        <div class="font-medium">Something went wrong!</div>
        <div class="text-gray-600 mt-1">Please check the fileld form.</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { computed, defineComponent, onMounted, reactive, ref, toRefs, watch } from 'vue'
import { useRoute } from 'vue-router'
import xlsx from 'xlsx'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import Toastify from 'toastify-js'
import { required, integer } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import axios from 'axios'
import { BASE_URL, v_per_page_record, v_per_page_size } from '@/constants/config.js'

const masterConfigs = {
  'inclusion-white': { title: 'Inclusion White', slug: 'inclusion_white' },
  'inclusion-black': { title: 'Inclusion Black', slug: 'inclusion_black' },
  'table-open': { title: 'Table Open', slug: 'table_open' },
  'side-open': { title: 'Side Open', slug: 'side_open' },
  milky: { title: 'Milky', slug: 'milky' }
}

export default defineComponent({
  setup() {
    const route = useRoute()
    const tableRef = ref()
    const tabulator = ref()
    const filter = reactive({
      field: 'name',
      type: 'like',
      value: ''
    })
    const form = reactive({
      name: '',
      short_code: '',
      synonyms: '',
      order: '',
      id: ''
    })
    const currentConfig = computed(() => masterConfigs[route.name] || masterConfigs.milky)
    const pageTitle = computed(() => currentConfig.value.title)
    const endpoint = (action) => `api/master/${action}_${currentConfig.value.slug}_details`
    const rules = {
      name: { required },
      short_code: { required },
      order: { integer }
    }
    const validate = useVuelidate(rules, toRefs(form))

    const resetForm = () => {
      form.name = ''
      form.short_code = ''
      form.synonyms = ''
      form.order = ''
      form.id = ''
      validate.value.$reset()
    }

    const initTabulator = () => {
      tabulator.value = new Tabulator(tableRef.value, {
        ajaxURL: BASE_URL + endpoint('get'),
        ajaxConfig: {
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=utf-8',
            Authorization: 'Bearer ' + localStorage.getItem('token')
          }
        },
        ajaxFiltering: true,
        ajaxSorting: true,
        printAsHtml: true,
        printStyled: true,
        pagination: 'remote',
        paginationSize: v_per_page_record,
        paginationSizeSelector: v_per_page_size,
        layout: 'fitColumns',
        headerSort: true,
        responsiveLayout: 'collapse',
        placeholder: 'No matching records found',
        columns: [
          {
            formatter: 'responsiveCollapse',
            width: 40,
            minWidth: 30,
            hozAlign: 'center',
            resizable: false,
            headerSort: false
          },
          { title: 'Name', minWidth: 120, responsive: 0, field: 'name', vertAlign: 'middle', print: false, download: false },
          { title: 'Short Code', minWidth: 100, field: 'short_code', hozAlign: 'center', vertAlign: 'middle', print: false, download: false },
          { title: 'Synonyms', minWidth: 160, field: 'synonyms', vertAlign: 'middle', print: false, download: false },
          { title: 'Order', minWidth: 100, field: 'order', hozAlign: 'center', vertAlign: 'middle', print: false, download: false },
          {
            title: 'Status',
            minWidth: 100,
            field: 'active_status',
            hozAlign: 'center',
            vertAlign: 'middle',
            print: false,
            download: false,
            formatter(cell) {
              return `<div class="flex items-center lg:justify-center ${
                cell.getData().active_status == 'Active' ? 'text-theme-9' : 'text-theme-6'
              }">
                <i data-feather="check-square" class="w-4 h-4 mr-2"></i> ${
                  cell.getData().active_status == 'Active' ? 'Active' : 'Inactive'
                }
              </div>`
            }
          },
          {
            title: 'Actions',
            minWidth: 100,
            field: 'actions',
            responsive: 1,
            hozAlign: 'center',
            vertAlign: 'middle',
            print: false,
            download: false,
            formatter(cell) {
              const a = cash(`<div class="flex lg:justify-center items-center">
                <a class="flex items-center mr-3" href="javascript:;">
                  <i data-feather="check-square" class="w-4 h-4 mr-1"></i> Edit
                </a>
              </div>`)
              cash(a).on('click', function() {
                getDetails(cell.getData().id)
              })
              return a[0]
            }
          },
          { title: 'Name', field: 'name', visible: false, print: true, download: true },
          { title: 'Short Code', field: 'short_code', visible: false, print: true, download: true },
          { title: 'Synonyms', field: 'synonyms', visible: false, print: true, download: true },
          { title: 'Order', field: 'order', visible: false, print: true, download: true },
          {
            title: 'Status',
            field: 'status',
            visible: false,
            print: true,
            download: true,
            formatterPrint(cell) {
              return cell.getValue() ? 'Active' : 'Inactive'
            }
          }
        ],
        renderComplete() {
          feather.replace({ 'stroke-width': 1.5 })
        }
      })
    }

    const reInitOnResizeWindow = () => {
      window.addEventListener('resize', () => {
        tabulator.value.redraw()
        feather.replace({ 'stroke-width': 1.5 })
      })
    }

    const onFilter = () => tabulator.value.setFilter(filter.field, filter.type, filter.value)

    const clearFilter = () => {
      filter.field = 'name'
      filter.type = 'like'
      filter.value = ''
      tabulator.value.clearFilter(true)
    }

    const getDetails = (id) => {
      return axios({
        url: endpoint('get') + '_by_id',
        method: 'POST',
        params: { id },
        baseURL: BASE_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        config: { headers: { Accept: 'application/json' } }
      }).then((result) => result.data)
        .then((data) => {
          form.name = data.item_details.name
          form.short_code = data.item_details.short_code
          form.synonyms = data.item_details.synonyms || ''
          form.order = data.item_details.order
          form.id = data.item_details.id
          cash('#new-order-modal').modal('show')
        })
        .catch(() => {})
    }

    const submitForm = () => {
      validate.value.$touch()
      if (validate.value.$invalid) {
        Toastify({
          node: cash('#failed-notification-content').clone().removeClass('hidden')[0],
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
        return
      }

      const promiseUrl = form.id != '' && form.id != null ? endpoint('update') : endpoint('add')
      return axios({
        url: promiseUrl,
        method: 'POST',
        data: {
          name: form.name,
          short_code: form.short_code,
          synonyms: form.synonyms,
          order: form.order,
          id: form.id
        },
        baseURL: BASE_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        config: { headers: { Accept: 'application/json' } }
      }).then((result) => result.data)
        .then(() => {
          Toastify({
            node: cash('#success-notification-content').clone().removeClass('hidden')[0],
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()

          cash('#new-order-modal').modal('hide')
          clearFilter()
          resetForm()
        })
        .catch(() => {})
    }

    const onResetFilter = () => {
      clearFilter()
    }

    const onExportCsv = () => tabulator.value.download('csv', 'data.csv')
    const onExportJson = () => tabulator.value.download('json', 'data.json')
    const onExportXlsx = () => {
      const win = window
      win.XLSX = xlsx
      tabulator.value.download('xlsx', 'data.xlsx', { sheetName: pageTitle.value })
    }
    const onExportHtml = () => tabulator.value.download('html', 'data.html', { style: true })
    const onPrint = () => tabulator.value.print()

    watch(() => route.name, () => {
      resetForm()
      if (tabulator.value) {
        tabulator.value.setData(BASE_URL + endpoint('get'))
      }
    })

    onMounted(() => {
      initTabulator()
      reInitOnResizeWindow()
    })

    return {
      tableRef,
      filter,
      form,
      pageTitle,
      validate,
      submitForm,
      onFilter,
      onResetFilter,
      onExportCsv,
      onExportJson,
      onExportXlsx,
      onExportHtml,
      onPrint,
      resetForm
    }
  }
})
</script>
